import { useEffect } from 'react'
import { toast } from 'react-toastify'

import { API } from 'api'

import { useAuth } from './providers/AuthProvider'
import { useModal } from './providers/ModalProvider'
import { getUserInfoFromStorage } from './helpers'

const AxiosInterceptors = ({ children }: { children: JSX.Element }) => {
  const { resetUser } = useAuth()
  const { resetModals } = useModal()

  useEffect(() => {
    const requestInterceptor = API.interceptors.request.use(
      (config) => {
        if (config.params) {
          Object.keys(config.params).forEach((key) => {
            if (config.params[key] === '') {
              delete config.params[key]
            }
          })
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    const responseInterceptor = API.interceptors.response.use(
      (response) => {
        return response
      },
      (err) => {
        const { error, message } = err.response.data
        const { method } = err.response.config
        if (method !== 'get' && error.status !== 409 && (message || error)) {
          toast.error(message || error)
        }
        if (err.response.status >= 500 && method !== 'get' && !error) {
          toast.error('Something went wrong')
        }
        const userId = getUserInfoFromStorage()
        if (err.response.status === 401 && userId) {
          resetUser()
          resetModals()
        }

        return Promise.reject(err)
      }
    )

    return () => {
      API.interceptors.request.eject(requestInterceptor)
      API.interceptors.response.eject(responseInterceptor)
    }
  }, [])

  return children
}

export default AxiosInterceptors
